// alert
import alert from '@drivesally/sally-ui/lib/libs/alert';

// error lib
import parseError from '@drivesally/sally-fw/lib/error/parseError';

// event HOCs
import subscriptionHOC from '@drivesally/sally-fw/lib/event/hoc/subscription.hoc.event';

// propTypes
import PropTypes from 'prop-types';

// react
import React, {Component} from 'react';

// react redux
import {connect} from 'react-redux';

// customer actions
import {set as setAction} from '../../../components/containers/templates/CustomerEditContainer/actions';

// driver api
import {getByID as getDriverByID} from '@drivesally/sally-fn/lib/driver/api';

// rental attributes
import customRepoReasonAttribute from '../../../repo/attributes/custom_repo_reason.attribute.repo';
import repoReasonAttribute from '../../../repo/attributes/repo_reason.attribute.repo';
import repoStartDateAttribute from '../../../repo/attributes/repo_start_date.attribute.repo';

// rental components
import RepoRentalModal from '../../components/RepoRentalModal/RepoRentalModal';

// rental events
import showRentalRepoEvent from '../../events/showRepoModal.event.rental';

// rental permissions
import repoRentalPermission from '../../permissions/repoRental.permission.rental';

// rental preparations
import repoRentalPreparation from '@drivesally/sally-fn/lib/rental/preparation/repo.preparation.rental';

// repo api
import createRepoApi from '@drivesally/sally-fn/lib/repo/api/create.api.repo';

// repo events
import createdEvent from '../../../repo/events/created.event.repo';

class RepoRentalContainer extends Component {
  static propTypes = {
    dispatch: PropTypes.func,
    subscribe: PropTypes.func,
    user: PropTypes.object,
  };

  state = {
    custom_repo_reason: customRepoReasonAttribute(''),
    driver: null,
    repo_reason: repoReasonAttribute(''),
    repo_start_date: repoStartDateAttribute(new Date()),
    saving: false,
    visible: false,
  };

  componentDidMount() {
    this.props.subscribe(showRentalRepoEvent.subscribe(this.show));
  }

  show = ({driver = null} = {}) => {
    if (!repoRentalPermission())
      return alert.warning('You do not have permission to repo this vehicle');
    this.setState({
      custom_repo_reason: customRepoReasonAttribute(''),
      driver,
      repo_reason: repoReasonAttribute(''),
      repo_start_date: repoStartDateAttribute(new Date()),
      visible: true,
    });
  };

  hide = () => {
    if (this.state.saving) return;
    this.setState({visible: false});
  };

  change = (value, key) => {
    if (this.state.saving) return;
    this.setState({[key]: value});
  };

  repoRental = async () => {
    const {user} = this.props;
    const {
      custom_repo_reason,
      driver,
      repo_reason,
      repo_start_date,
      saving,
    } = this.state;
    if (!driver || saving) return;

    this.setState({saving: true});

    try {
      const repoBody = await repoRentalPreparation({
        custom_repo_reason,
        repo_reason,
        repo_start_date,
      });
      const newRepo = await createRepoApi({
        ...repoBody,
        repo_initiated_by: user.id,
        driver: driver.id,
      });
      createdEvent.publish(newRepo);
      try {
        const customer = await getDriverByID(driver.id);
        this.props.dispatch(setAction({customer}));
      } catch (_e) {
        // Repo already succeeded; driver refresh is best-effort.
      }
      alert.success('Repo initiated');
      this.setState({saving: false, visible: false});
    } catch (e) {
      const {message} = parseError(e);
      alert.error(message);
      this.setState({saving: false});
    }
  };

  render() {
    const {
      custom_repo_reason,
      repo_reason,
      repo_start_date,
      saving,
      visible,
    } = this.state;

    return (
      <RepoRentalModal
        custom_repo_reason={custom_repo_reason}
        onChange={this.change}
        onClose={this.hide}
        onSave={this.repoRental}
        repo_reason={repo_reason}
        repo_start_date={repo_start_date}
        saving={saving}
        visible={visible}
      />
    );
  }
}

export default connect((state) => ({
  user: state.authorization.userData,
}))(subscriptionHOC(RepoRentalContainer));
